import { File as FileModel } from "./File";
import { JobQualifications as JobQualificationsModel } from "./JobQualification";

export interface Job {
    job_id: number;

    team_broadcast_background: string;
    job_type_id: number;
    job_type: any; // figure it out
    location: any; // figure it out
    location_id: number;
    is_open: boolean;
    open_positions: number;
    primary_job_category_name: string;
    primary_job_category_id: number;
    primary_job_position_id: number;
    primary_job_position_name: string;
    secondary_job_positions: Array<{
        category_id: number;
        category_name: string;
        position_id: number;
        position_name: string;
    }>;
    job_name: string;
    benefits: string[];
    has_benefits: boolean;
    duration_details: string[];
    has_duration_details: boolean;
    broadcast_description: string;

    job_qualifications: JobQualificationsModel;

    //from job details page
    primary_job_position_display_name: string;

    reviewed_referrals?: number;
    considered_referrals?: number;
    eliminated_referrals?: number;
    hired_referrals?: number;
    total_commission_in_us_dollars: string;
    submission_commission_in_us_dollars: string;
    interview_commission_in_us_dollars: string;
    hire_commission_in_us_dollars: string;
    attachments: any[]; // figure it out
    user_has_access: boolean;
    employment_guarantee: string;
    employment_guarantee_payment: string;
    job_salary_description: string;
    company_name: string;
    total_messages: number;
    unread_messages: number;
    job_description: string;

    application_id?: number;
    application_status?: string;
    application_date?: string;
}

export const GetEmptyJob = (): Job => {
    return {
        job_id: 0,
        team_broadcast_background: "",
        job_type_id: 0,
        job_type: {},
        location: {},
        job_description: "",
        location_id: 0,
        is_open: false,
        open_positions: 0,
        primary_job_category_name: "",
        primary_job_category_id: 0,
        primary_job_position_id: 0,
        primary_job_position_name: "",
        job_name: "",
        benefits: [] as string[],
        has_benefits: false,
        duration_details: [] as string[],
        has_duration_details: false,
        broadcast_description: "",

        job_qualifications: {} as JobQualificationsModel,

        attachments: [] as FileModel[],
        secondary_job_positions: [],
        user_has_access: false,
        total_commission_in_us_dollars: "",
        submission_commission_in_us_dollars: "",
        interview_commission_in_us_dollars: "",
        hire_commission_in_us_dollars: "",
        employment_guarantee: "",
        employment_guarantee_payment: "",
        job_salary_description: "",
        company_name: "",
        total_messages: 0,
        unread_messages: 0,
        primary_job_position_display_name: "",
    };
};
